<template>
  <CustomModal :value="show" :title="title" @cancel="cancel" @save="save">
    <ValidationObserver
      ref="formModalObserver"
      tag="form"
      novalidate
      @submit.prevent="save"
    >
      <div class="row">
        <div class="col-12">
          <ValidationProvider v-slot="{ errors }" mode="eager" rules="required|max:3000">
            <div class="form-group">
              <label>Comentario</label>
              <textarea
                v-model="comment"
                class="form-control"
                rows="4"
                maxlength="3000"
                :class="{ 'is-invalid': errors[0] }"
              ></textarea>
              <div v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</div>
              <small class="form-text text-right" :class="{ 'text-danger': comment.length >= 2500 }">
                {{ comment.length }} / 3000
              </small>
            </div>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
  </CustomModal>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import CustomModal from '@/components/common/CustomModal';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'CancelPeiModal',
  mixins: [alert],
  components: {
    CustomModal,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    show: false,
    title: 'Cancelar PEI',
    comment: '',
  }),
  methods: {
    open() {
      this.comment = '';
      this.show = true;
    },
    async cancel() {
      await this.$refs.formModalObserver.reset();
      this.comment = '';
      this.show = false;
      this.$emit('cancel');
    },
    async save() {
      let self = this;

      const isValid = await self.$refs.formModalObserver.validate();

      if (!isValid) {
        this.ShowToast('Atención', 'Por favor, complete el comentario.', 'error');
        return;
      }

      self.show = false;
      self.$emit('save', { peiCancelComment: self.comment });
      self.comment = '';
    },
  },
};
</script>